<template>
  <report-settings-form :action="route('settings.contribution')" class="grid gap-3 max-w-xs">
    <l-input
      id="y1_contribution"
      v-model="user.finances.y1_contribution"
      label="1st year"
      name="y1_contribution"
      type="number"
      prefix="$"
      min="0"
    />

    <l-input
      id="y2_contribution"
      v-model="user.finances.y2_contribution"
      label="2nd year"
      name="y2_contribution"
      type="number"
      prefix="$"
      min="0"
    />

    <l-input
      id="y3_contribution"
      v-model="user.finances.y3_contribution"
      label="3rd year"
      name="y3_contribution"
      type="number"
      prefix="$"
      min="0"
    />

    <l-input
      id="y4_contribution"
      v-model="user.finances.y4_contribution"
      label="4th year"
      name="y4_contribution"
      type="number"
      prefix="$"
      min="0"
    />

    <l-input
      id="y5_contribution"
      v-model="user.finances.y5_contribution"
      label="5th year"
      name="y5_contribution"
      type="number"
      prefix="$"
      min="0"
    />
  </report-settings-form>
</template>

<script setup>
import LInput from "@/components/inputs/LInput.vue"
import ReportSettingsForm from "@/components/forms/ReportSettingsForm.vue"
import route from "ziggy-js"

const user = defineModel({ type: Object, required: true })
</script>
